import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Layout, Drawer, Affix, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons"; // ✅ hamburger icon
import Sidenav from "./Sidenav";
import Header from "./Header";
import Footer from "./Footer";
import { Container } from "react-bootstrap";

const { Header: AntHeader, Content, Sider } = Layout;

function Main({ children }) {
  const [visible, setVisible] = useState(false);
  const [placement, setPlacement] = useState("right");
  const [sidenavColor, setSidenavColor] = useState("#1890ff");
  const [sidenavType, setSidenavType] = useState("transparent");
  const [fixed, setFixed] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  // ✅ responsive check
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const openDrawer = () => setVisible(true);
  const closeDrawer = () => setVisible(false);

  let { pathname } = useLocation();
  pathname = pathname.replace("/", "");

  useEffect(() => {
    if (pathname === "rtl") {
      setPlacement("left");
    } else {
      setPlacement("right");
    }
  }, [pathname]);

  return (
    <div className="for-all-page-background">
      {fixed ? (
        <Affix>
          <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}> 
             
              <Header
               onPress={openDrawer}
                name={pathname}
                subName={pathname}
                handleSidenavColor={setSidenavColor}
                handleSidenavType={setSidenavType}
                handleFixedNavbar={setFixed}
              /> 
          </AntHeader>
        </Affix>
      ) : (
        <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}> 
            <Header
            onPress={openDrawer}
              name={pathname}
              subName={pathname}
              handleSidenavColor={setSidenavColor}
              handleSidenavType={setSidenavType}
              handleFixedNavbar={setFixed}
            /> 
        </AntHeader>
      )}

      <Container fluid>
        <Layout> 
          {isMobile && (
            <Drawer
              title={false}
              placement="left"
              closable={false}
              onClose={closeDrawer}
              open={visible}
              width={collapsed ? 250 : 250}
              className={`drawer-sidebar ${
                pathname === "rtl" ? "drawer-sidebar-rtl" : ""
              }`}
            >
              <Layout
                className={`layout-dashboard ${
                  pathname === "rtl" ? "layout-dashboard-rtl" : ""
                }`}
              >
                <Sider
                  trigger={null}
                  width={collapsed ? 215 : 215}
                  theme="light"
                  collapsed={collapsed}
                  className={`sider-primary ant-layout-sider-primary ${
                    sidenavType === "#fff" ? "active-route" : ""
                  }`}
                  style={{ background: sidenavType }}
                >
                  <Sidenav
                    color={sidenavColor}
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                     closeDrawer={closeDrawer}  
                      isMobile={isMobile}   
                  />
                </Sider>
              </Layout>
            </Drawer>
          )}
 
          {!isMobile && (
            <Sider
              breakpoint="lg"
              collapsedWidth="60"
              collapsed={collapsed}
              onCollapse={(value) => setCollapsed(value)}
              trigger={null}
              width={collapsed ? 60 : 215}
              theme="light"
              className={`sider-primary ant-layout-sider-primary ${
                sidenavType === "#fff" ? "active-route" : ""
              }`}
              style={{
                background: sidenavType,
                transition: "width 0.3s ease",
              }}
            >
              <Sidenav
                color={sidenavColor}
                collapsed={collapsed}
                setCollapsed={setCollapsed}
              />
            </Sider>
          )}

          <Content className="content-ant">{children}</Content>
        </Layout>
      </Container>
      <Footer />
    </div>
  );
}

export default Main;
